import React from "react";
import { Icon, IconButton, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";

const maskDdd = (value) => {
    let r = value ? value.replace(/\D/g, "") : "";
    if (r.length > 2) r = r.slice(0, 2);
    return r;
};

const maskPhone = (value) => {
    let r = value ? value.replace(/\D/g, "") : "";
    if (r.length > 9) r = r.slice(0, 9);
    if (r.length === 9) {
        r = r.replace(/^(\d{5})(\d{4}).*/, "$1-$2");
    } else if (r.length > 4) {
        r = r.replace(/^(\d{4})(\d{0,4}).*/, "$1-$2");
    }
    return r;
};

export default function DevedorTelefoneSection({ values, setFieldValue, handleChange, isViewOnly }) {
    return (
        <MDBox mt={2}>
            <FieldArray name="telefones">
                {({ push, remove }) => (
                    <>
                        <MDBox display="flex" justifyContent="flex-end" mb={1}>
                            <MDButton variant="contained" color="info" size="small" onClick={() => push({ ccDdd: '', ccTelefone: '', cvTipo: 2, cvOrigem: 1, ccContato: '', cbRuim: false, cbBlackList: false })}>
                                <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar Telefone
                            </MDButton>
                        </MDBox>
                        {values.telefones.length > 0 && (
                            <TableContainer sx={{ boxShadow: "none" }}>
                                <Table>
                                    <MDBox component="thead">
                                        <TableRow>
                                            <DataTableHeadCell width="8%" sorted={false}>DDD</DataTableHeadCell>
                                            <DataTableHeadCell width="20%" sorted={false}>Telefone</DataTableHeadCell>
                                            <DataTableHeadCell width="15%" sorted={false}>Tipo</DataTableHeadCell>
                                            <DataTableHeadCell width="18%" sorted={false}>Origem</DataTableHeadCell>
                                            <DataTableHeadCell width="22%" sorted={false}>Contato</DataTableHeadCell>
                                            <DataTableHeadCell width="6%" align="center" sorted={false}>Ruim</DataTableHeadCell>
                                            <DataTableHeadCell width="6%" align="center" sorted={false}>Blacklist</DataTableHeadCell>
                                            <DataTableHeadCell width="8%" align="center" sorted={false}>Ações</DataTableHeadCell>
                                        </TableRow>
                                    </MDBox>
                                    <TableBody>
                                        {values.telefones.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        fullWidth 
                                                        size="small"
                                                        name={`telefones[${index}].ccDdd`}
                                                        value={values.telefones[index].ccDdd} 
                                                        onChange={(e) => setFieldValue(`telefones[${index}].ccDdd`, maskDdd(e.target.value))} 
                                                        placeholder="00"
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        fullWidth 
                                                        size="small"
                                                        name={`telefones[${index}].ccTelefone`}
                                                        value={values.telefones[index].ccTelefone} 
                                                        onChange={(e) => setFieldValue(`telefones[${index}].ccTelefone`, maskPhone(e.target.value))} 
                                                        placeholder="00000-0000"
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        select 
                                                        fullWidth 
                                                        size="small"
                                                        name={`telefones[${index}].cvTipo`}
                                                        value={values.telefones[index].cvTipo} 
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem value={1}>Fixo</MenuItem>
                                                        <MenuItem value={2}>Celular</MenuItem>
                                                        <MenuItem value={3}>WhatsApp</MenuItem>
                                                    </MDInput>
                                                </TableCell>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        select 
                                                        fullWidth 
                                                        size="small"
                                                        name={`telefones[${index}].cvOrigem`}
                                                        value={values.telefones[index].cvOrigem} 
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem value={1}>Serasa</MenuItem>
                                                        <MenuItem value={2}>Boa Vista</MenuItem>
                                                        <MenuItem value={3}>Cliente</MenuItem>
                                                        <MenuItem value={4}>Informado</MenuItem>
                                                        <MenuItem value={5}>Outros</MenuItem>
                                                        <MenuItem value={6}>Remessa</MenuItem>
                                                    </MDInput>
                                                </TableCell>
                                                <TableCell sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <MDInput 
                                                        fullWidth 
                                                        size="small"
                                                        name={`telefones[${index}].ccContato`}
                                                        value={values.telefones[index].ccContato} 
                                                        onChange={handleChange} 
                                                        placeholder="Falar com..."
                                                    />
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <Switch 
                                                        checked={values.telefones[index].cbRuim} 
                                                        onChange={(e) => setFieldValue(`telefones[${index}].cbRuim`, e.target.checked)} 
                                                    />
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <Switch 
                                                        checked={values.telefones[index].cbBlackList} 
                                                        onChange={(e) => setFieldValue(`telefones[${index}].cbBlackList`, e.target.checked)} 
                                                        color="error" 
                                                    />
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 1, px: 1, verticalAlign: "middle" }}>
                                                    <IconButton color="error" size="small" onClick={() => remove(index)}>
                                                        <Icon>delete</Icon>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </>
                )}
            </FieldArray>
        </MDBox>
    );
}
